<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <!-- 検索条件エリア -->
          <v-col cols="4">
            <TextFieldInput :label="$t('ELE0012')" v-model="searchCondition.defectCd" />
          </v-col>
          <v-col cols="4">
            <TextFieldInput :label="$t('ELE0013')" v-model="searchCondition.defectName" />
          </v-col>
          <v-col cols="4">
            <DefectGroupInput v-model="searchCondition.defectGroupCd" validOnly />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <span class="d-flex flex-row space-between mr-4">
              <Checkbox :label="$t('ELE0022')" v-model="searchCondition.validOnly" />
              <v-spacer />
              <BtnSearch class="mt-2" @click="onClickSearch" />
            </span>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
                <v-spacer />
                <BtnAdd @click="addItem" />
              </v-card-title>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:[`item.action`]="{ item }">
                  <IconInquiry @click="inquiryItem(item)" left />
                  <IconEdit @click="editItem(item)" right />
                </template>
                <template v-slot:[`item.isValid`]="{ item }">
                  {{ $t('isValid.' + item.isValid) }}
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
    <DefectDialog
      v-if="item !== null"
      :dialog.sync="dialog"
      :mode="mode"
      :defectCd.sync="item.defectCd"
      :defectName.sync="item.defectName"
      :defectGroupCd.sync="item.defectGroupCd"
      :isValid.sync="item.isValid"
      :versionNo.sync="item.versionNo"
      @change="onClickSearch()"
    />
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import { ModalMode } from '@/enum'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import cloneDeep from 'lodash/cloneDeep'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import Btn from '@/components/atoms/base/button/Btn'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import IconEdit from '@/components/atoms/icon/IconEdit'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import DefectDialog from '@/components/organisms/master/dialog/DefectDialog'
import DefectGroupInput from '@/components/atoms/select/DefectGroupInput'

export default {
  name: 'DefectForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    TextFieldInput,
    Btn,
    Checkbox,
    DefectDialog,
    DefectGroupInput,
    BtnSearch,
    BtnAdd,
    IconEdit,
    IconInquiry,
  },

  data() {
    return {
      dialog: false,
      mode: '',
      searchCondition: {
        defectCd: '',
        defectName: '',
        defectGroupCd: '',
        validOnly: true,
      },
      items: [],
      item: null,
      headers: [
        { text: '', align: 'start', divider: true, width: '90', sortable: false, value: 'action' },
        { text: this.$t('ELE0012'), divider: true, value: 'defectCd' },
        { text: this.$t('ELE0013'), divider: true, value: 'defectName' },
        { text: this.$t('ELE0009'), divider: true, value: 'defectGroupCd' },
        { text: this.$t('ELE0010'), divider: true, value: 'defectGroupName' },
        { text: this.$t('ELE0014'), divider: true, value: 'isValid' },
        { text: this.$t('ELE0029'), divider: true, value: 'itemUpdatedBy' },
        { text: this.$t('ELE0039'), divider: true, value: 'updaterUserName' },
        { text: this.$t('ELE0030'), divider: false, value: 'editItemUpdatedAt' },
      ],
      emptyItem: {
        defectCd: '',
        defectName: '',
        defectGroupCd: '',
        isValid: true,
        versionNo: 0,
      },
    }
  },

  methods: {
    addItem() {
      this.mode = ModalMode.ADD
      this.item = cloneDeep(this.emptyItem)
      this.dialog = true
    },
    editItem(item) {
      this.mode = ModalMode.EDIT
      this.item = cloneDeep(item)
      this.dialog = true
    },
    inquiryItem(item) {
      this.mode = ModalMode.INQUIRY
      this.item = cloneDeep(item)
      this.dialog = true
    },
    async onClickSearch() {
      this.startLoading()

      try {
        const params = {
          defectCd: this.searchCondition.defectCd,
          defectName: this.searchCondition.defectName,
          defectGroupCd: this.searchCondition.defectGroupCd,
          validOnly: this.searchCondition.validOnly,
        }
        this.items = []
        const elements = await API.get('/master/defects', params)
        elements.forEach((element) => {
          element['editItemUpdatedAt'] = this.toLocalTime(element['itemUpdatedAt'])
          element['defectGroupName'] = element['m_defectGroup']['defectGroupName']
          element['defectGroupCd'] = element['m_defectGroup']['defectGroupCd']
          element['updaterUserName'] = element['m_user']['userName']
          this.items.push(element)
        })
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0011') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    this.onClickSearch()
  },
}
</script>
